// extracted by mini-css-extract-plugin
export var hidden = "DownloadButton-module--hidden--2dYz_";